export const PATHS = {
  AUTH: {
    LOGIN: "/login",
    FORBIDDEN: "/forbidden",
  },
  // Danh sách đơn hàng
  ORDERS: {
    ROOT: "/orders",
    CREATE_SINGLE: "/orders/create-product",
    CREATE_MULTI: "/orders/create-products",
    EDIT: "/orders/edit-product",
    VIEW: "/orders/view",
  },
  // Quản lý Master Data
  MASTER_DATA: {
    CUSTOMERS: "/master-data/customers",
    CUSTOMERS_CREATE: "/master-data/customers/create",
  },
  WAIT_TIME: {
    ROOT: "/wait-time",
  },
  SALES: {
    ROOT: "/sales",
  },
  SELLER_PRODUCTS: {
    ROOT: "/seller-products",
  },
  COMPANY_REGISTRATIONS: {
    ROOT: "/company-registration-requests",
  },
  PRODUCT_DEADLINE: {
    ROOT: "/product-deadline",
    NEW: "/product-deadline/new",
  },
  PROPOSES: {
    ROOT: "/proposes",
    TEMPLATES: "/proposes/templates",
    CREATE: "/proposes/create",
    NEW: "/proposes/new",
    EDIT: "/proposes/edit",
    VIEW: "/proposes/view",
  },
};

export const ROUTE_META = {
  [PATHS.ORDERS.ROOT]: {
    title: "注文一覧",
    parent: null,
  },

  [PATHS.ORDERS.CREATE_SINGLE]: {
    title: "単一作成",
    parent: PATHS.ORDERS.ROOT,
  },

  [PATHS.ORDERS.CREATE_MULTI]: {
    title: "複数作成",
    parent: PATHS.ORDERS.ROOT,
  },

  [PATHS.ORDERS.EDIT]: {
    title: "注文編集",
    parent: PATHS.ORDERS.ROOT,
  },

  [PATHS.ORDERS.VIEW]: {
    title: "注文詳細",
    parent: PATHS.ORDERS.ROOT,
  },

  [PATHS.MASTER_DATA.CUSTOMERS]: {
    title: "顧客管理",
  },

  [PATHS.MASTER_DATA.CUSTOMERS_CREATE]: {
    title: "顧客作成",
  },

  [PATHS.WAIT_TIME.ROOT]: {
    title: "待機時間管理",
  },

  [PATHS.SALES.ROOT]: {
    title: "営業担当者管理",
  },

  [PATHS.SELLER_PRODUCTS.ROOT]: {
    title: "販売担当商品設定",
  },

  [PATHS.COMPANY_REGISTRATIONS.ROOT]: {
    title: "会社登録申請管理",
  },

  [PATHS.PRODUCT_DEADLINE.ROOT]: {
    title: "注文期限管理",
  },

  [PATHS.PRODUCT_DEADLINE.NEW]: {
    title: "新規設定",
    parent: PATHS.PRODUCT_DEADLINE.ROOT,
  },
  [PATHS.PROPOSES.ROOT]: { title: "販売提案管理" },
  [PATHS.PROPOSES.TEMPLATES]: { title: "テンプレート管理", parent: PATHS.PROPOSES.ROOT },
  [PATHS.PROPOSES.CREATE]: { title: "提案作成", parent: PATHS.PROPOSES.ROOT },
  [PATHS.PROPOSES.NEW]: { title: "新規提案を作成", parent: PATHS.PROPOSES.ROOT },
  [PATHS.PROPOSES.EDIT]: { title: "提案編集", parent: PATHS.PROPOSES.ROOT },
  [PATHS.PROPOSES.VIEW]: { title: "提案詳細", parent: PATHS.PROPOSES.ROOT },
};
